import { render, staticRenderFns } from "./testPage.vue?vue&type=template&id=96babe96&scoped=true&"
import script from "./testPage.vue?vue&type=script&lang=ts&"
export * from "./testPage.vue?vue&type=script&lang=ts&"
import style0 from "./testPage.vue?vue&type=style&index=0&id=96babe96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96babe96",
  null
  
)

export default component.exports